export const habaMyAccountNavigation = {
  myAccountNavigation: {
    customerData: {
      changeData: 'Modifier les données client',
      label: 'Données des clients',
      kidsDataManagement: 'Gérer les données des enfants',
    },
    general: {
      article: 'Mes articles',
      history: 'Mes commandes',
      overview: 'Mon aperçu',
      premium: 'Envoi premium',
      return: 'Mes retours',
      wishlist: 'Ma liste de souhaits',
    },
    navigation: {
      heading: 'Aperçu du compte',
      orders: 'Mes commandes',
      clientData: 'Mes données client',
      personalData: 'Données personnelles',
      loginData: 'Données de connexion',
      billingAddress: 'Adresse de facturation',
      deliveryAddress: 'Mes adresses de livraison',
    },
  },
};
